import { render, staticRenderFns } from "./GroupGridAlert.vue?vue&type=template&id=e95871f0&scoped=true&"
import script from "./GroupGridAlert.vue?vue&type=script&lang=ts&"
export * from "./GroupGridAlert.vue?vue&type=script&lang=ts&"
import style0 from "./GroupGridAlert.vue?vue&type=style&index=0&id=e95871f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95871f0",
  null
  
)

export default component.exports